module.exports = __webpack_public_path__ + "img/238.ac19ca0e.png";